import { Text, Flex } from '@radix-ui/themes'

export const RecordPage = () => {
  return (
    <Flex direction="column" gap="4" align="center">
      <Text size="5" weight="bold">
        음식 기록하기
      </Text>
      <Text color="gray">오늘 먹은 음식을 기록해보세요</Text>
    </Flex>
  )
}